import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { orders as ordersApi } from '@afosto/order/api/Orders';
import { invoices as invoicesApi } from '@afosto/order/api/Invoices';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';

const ReferenceFormatter = ({ id, type, typographyVariant }) => {
  const [referenceData, setReferenceData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchOrder = async authorizationId => {
      try {
        const response = await ordersApi.listOrders({ authorizationId });
        const { data = [] } = response;

        if (isMounted && data?.length > 0) {
          const [firstOrder] = data;
          setReferenceData({ number: firstOrder.number, id: firstOrder.id, slug: '/orders/' });
        }
      } catch (error) {
        if (isMounted) {
          setReferenceData(null);
        }
      }
    };

    const fetchInvoice = async invoiceID => {
      try {
        const response = await invoicesApi.viewInvoice(invoiceID);
        const { data = {} } = response;

        if (isMounted) {
          setReferenceData({ number: data.number, id: data.id, slug: '/invoices/' });
        }
      } catch (error) {
        if (isMounted) {
          setReferenceData(null);
        }
      }
    };

    if (type === 'authorization') {
      fetchOrder(id);
    }

    if (type === 'invoice') {
      fetchInvoice(id);
    }

    return () => {
      isMounted = false;
    };
  }, [id, type]);

  return (
    <MuiLink
      variant={typographyVariant}
      component={Link}
      to={`${referenceData?.slug}${referenceData?.id}`}
    >
      {referenceData?.number ?? '-'}
    </MuiLink>
  );
};

ReferenceFormatter.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  typographyVariant: PropTypes.string,
};

ReferenceFormatter.defaultProps = {
  id: null,
  type: null,
  typographyVariant: 'subtitle1',
};

export default ReferenceFormatter;
